export const DUPLICATE_PO_FALLBACK_MESSAGE =
  'This PO number has already been used for this venue. Please change the PO number and try again.'

export function getDuplicatePOValidationMessage(errorMessage) {
  const message = String(errorMessage || '').trim()
  return message || DUPLICATE_PO_FALLBACK_MESSAGE
}
